import { Grid, TextField, Typography, Button} from '@mui/material'
import colors from '../../../colors'
import React from 'react' 
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData} from '../../../../features/userInfo/topUpSlice'
import {selectUserInfo} from '../../../../features/userInfo/userInfoSlice'
import {selectGlobalDataState} from '../../../../features/global/globalDataSlice'
import { sendGeneralRequest } from '../../../../features/generalRequest'
import { makeStyles } from '@mui/styles';
import { texts } from '../../../general/texts'

export const TopUpBankInactive = (props) => {

    const dispatch = useDispatch()
    const topUpData = useSelector(selectTopUpData)
    const userInfo = useSelector(selectUserInfo)
    const globalDataSliceState = useSelector(selectGlobalDataState)

    const [request, setRequest] = React.useState({
        token: globalDataSliceState.token,
        cifCode: '',
        bankId: topUpData.selectedBank.bankId
    })

    const handleButtonClick = () => 
    {
        dispatch(sendGeneralRequest({request: request, baseUrlKey:'services', endpoint:'DirectDebit/AddBankAccount'}))
    }

    const handleSubmit = (e) => 
    {
        e.preventDefault()
        handleButtonClick()
    }

    const onTextFieldChange = (prop) => (event) => 
    {
        setRequest({
            ...request,
            [prop] : event.target.value
        })
    } 

    const useStyles = makeStyles({
        header:{
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            color:colors.darkBlue,
            textAlign:'left'
        },
        text:{
            fontSize:'1rem',
            fontFamily:'GerberaLight',
            color:colors.darkBlue,
            textAlign:'left'
        },
        button:{
            height:'100%',
            width:'110%',
            backgroundColor:colors.lightGreen,
            color:colors.white,
            fontFamily:'GerberaBold',
            textTransform:'none',
            background:colors.lightGreen,
            "&:hover":{background:colors.lightGreen}
        }
    })

    const classes = useStyles()

    return (
        <form>
            <Grid container item md={12} spacing={3}>
            <Grid container item md={12} alignItems='flex-start' direction='column' >
                <Grid item><Typography className={classes.header}>{texts["message-bank-not-linked"]}</Typography> </Grid>
            </Grid>
            <Grid container item md={12} alignItems='flex-start' direction='column' >
                <Grid item>
                    <Typography className={classes.text}>
                    {topUpData.selectedBank.bankName === 'BKT' && texts["message-bank-not-linked-bkt"]}
                        {topUpData.selectedBank.bankName === 'Union Bank' && texts["message-warning-union-bank-not-linked"]}
                        {topUpData.selectedBank.bankName === 'UBA' && texts["message-warning-uba-bank-not-linked"]}
                    </Typography> 
                </Grid>
            </Grid>
            {
                topUpData.selectedBank.bankName === 'Union Bank' && 
                <Grid container item md={12} alignItems='flex-start' direction='column' >
                    <Grid item><Typography className={classes.header}>{topUpData.bankId}</Typography></Grid>
                </Grid>
            }
            <Grid container item md={12} alignItems='flex-start' direction='column' >
                <Grid item><Typography  className={classes.text}>{texts["message-bank-not-linked-confirm-cif"]}</Typography> </Grid>
            </Grid>
            <Grid container item  md={12} alignItems='flex-start' spacing={2}>
                <Grid item><Typography className={classes.header}>{texts["prompt-cif-code"]}</Typography></Grid>
                <Grid container item md={12} justifyContent='flex-start'>
                    <Grid container item md={12}  direction='row' spacing={1.7}>
                        <Grid item>
                            <TextField onChange={onTextFieldChange('cifCode')} id="standard-helper-text" size='small' label="Kodi CIF" color='warning' />
                        </Grid>
                        <Grid item><Button type='submit' onClick={(e)=>{handleSubmit(e)}} className={classes.button}>{texts["button-confirm"]}</Button></Grid>
                    </Grid>     
                </Grid>            
            </Grid>
        </Grid>
        </form>
    )
}
export default TopUpBankInactive
